import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import DestinationMRT from "../../components/MRT/destinationMRT";
import PaymentMethodMRT from "../../components/MRT/paymentmethodMRT";
import DataMRT from "../../components/MRT/dataMRT";

const MRTPage = () => {
  return (
    // <Box>
    //   {/* TITLE */}
    //   <Typography
    //     variant="h4"
    //     align="center"
    //     sx={{ fontWeight: 600, my: 4, color: "#092b4dff" }}
    //   >
    //     Data MRT Jakarta
    //   </Typography>

    //   {/* === CHART SECTION === */}
    //   <Box
    //     sx={{
    //       display: "flex",
    //       flexDirection: "row",
    //       gap: 2,
    //       mb: 3,
    //       minWidth: 0,
    //       flexWrap: { xs: "wrap", md: "nowrap" },
    //     }}
    //   >
    //     <Box sx={{ flex: "1 1 60%", minWidth: 0, display: "flex" }}>
    //       <DestinationMRT />
    //     </Box>

    //     <Box sx={{ flex: "1 1 40%", minWidth: 0, display: "flex" }}>
    //       <PaymentMethodMRT />
    //     </Box>
    //   </Box>

    //   {/* === TABLE SECTION === */}

    //   <Grid container spacing={3} mt={2}>
    //     <Box sx={{ width: "100%", mt: 3 }}>
    //       <DataMRT />
    //     </Box>
    //   </Grid>
    // </Box>
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data MRT Jakarta"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=148&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5ODc2MzU0LCJJZGVudGl0eSI6MTQ4LCJUb2tlblR5cGUiOjB9.OXlVKrdH_Qx2TGe9btU_WM6tVfi-ggmgKDqlBf1CFSY&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default MRTPage;
